module.exports = __webpack_public_path__ + "img/jdGoods.ef44c8e3.svg";